'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unmaskEvent = exports.removeMask = exports.addMask = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vanillaMasker = require('vanilla-masker');

var _vanillaMasker2 = _interopRequireDefault(_vanillaMasker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addMask = exports.addMask = function addMask(value, format) {
  return _vanillaMasker2.default.toPattern(value.replace(/[^0-9]/g, ''), format);
};

var removeMask = exports.removeMask = function removeMask(value) {
  return value.replace(/[^0-9]/g, '');
};

var unmaskEvent = exports.unmaskEvent = function unmaskEvent(event) {
  return (0, _extends3.default)({}, event, {
    target: (0, _extends3.default)({}, event.target, {
      value: removeMask(event.target.value)
    })
  });
};